import { Link } from "react-router-dom";
import { Instagram, Linkedin } from "lucide-react";
import { handleExternalClick } from "@/lib/externalLink";

function TikTokIcon({ className, size }: { className?: string; size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 20}
      height={size ?? 20}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
    </svg>
  );
}

const BRAND_GREEN = "#166534";
const BRAND_GOLD = "#C4922A";

const linkClass = "text-white/70 hover:text-[#C4922A] transition-colors";

export default function PublicFooter() {
  const year = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: BRAND_GREEN }} className="text-white">
      <div className="container py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="font-heading text-base font-medium tracking-tight text-white">
              oplif<span style={{ color: BRAND_GOLD }}>.</span>
            </Link>
            <p className="mt-2 text-xs text-white/65 leading-relaxed max-w-[14rem]">
              The operating system for hospitality — built to open smarter and run better.
            </p>
            <div className="mt-3 flex items-center gap-3">
              <a
                href="https://instagram.com/oplifapp"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleExternalClick}
                className="text-white/70 hover:text-white/100 transition-opacity"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://tiktok.com/@oplifapp"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleExternalClick}
                className="text-white/70 hover:text-white/100 transition-opacity"
                aria-label="TikTok"
              >
                <TikTokIcon size={20} />
              </a>
              <a
                href="https://linkedin.com/company/oplif"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleExternalClick}
                className="text-white/70 hover:text-white/100 transition-opacity"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-medium text-white uppercase tracking-wider mb-3">Company</h4>
            <ul className="space-y-2 text-[13px]">
              <li><Link to="/our-story" className={linkClass}>Our Story</Link></li>
              <li><Link to="/mission" className={linkClass}>Mission</Link></li>
              <li><Link to="/press" className={linkClass}>Press</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-medium text-white uppercase tracking-wider mb-3">Product</h4>
            <ul className="space-y-2 text-[13px]">
              <li><Link to="/features" className={linkClass}>Features</Link></li>
              <li><Link to="/pricing" className={linkClass}>Pricing</Link></li>
              <li><Link to="/#how" className={linkClass}>How it works</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-medium text-white uppercase tracking-wider mb-3">Support</h4>
            <ul className="space-y-2 text-[13px]">
              <li><Link to="/contact" className={linkClass}>Contact</Link></li>
              <li><Link to="/terms" className={linkClass}>Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/15 pt-6 text-xs text-white/60 flex flex-wrap items-center gap-x-3 gap-y-1">
          <span>© {year} Oplif LLC. All rights reserved.</span>
          <button
            type="button"
            onClick={() => {
              const w = window as unknown as { _iub?: { cs?: { api?: { openPreferences?: () => void } } } };
              w._iub?.cs?.api?.openPreferences?.();
            }}
            className="text-white/50 hover:text-white/85 transition-colors underline-offset-2 hover:underline"
          >
            Your Privacy Choices
          </button>
          <a
            href="https://www.iubenda.com/privacy-policy/50445777"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleExternalClick}
            className="text-white/50 hover:text-white/85 transition-colors underline-offset-2 hover:underline"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}
